import React from "react";

import "./resourse.css";

export default function ResourseTile(props) {
  const isLoggedIn = Boolean(
    props?.state?.payload ||
    localStorage.getItem("token") ||
    localStorage.getItem("payload") ||
    sessionStorage.getItem("token") ||
    sessionStorage.getItem("payload")
  );
  return (
    <div className="resource-vendor-card" style={{ margin: "10px" }}>
      {/* Circular Photo/Logo */}
      <div
        className="resource-vendor-logo"
        style={
          props?.photo
            ? {
                backgroundImage: `url(${props?.photo ?? props?.candidate_details?.photo})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
              }
            : { backgroundColor: "#0a223d", color: "#fff" }
        }
      >
        {!props?.photo && props?.title?.[0]?.toUpperCase()}
      </div>

      {/* Title */}
      <h5 className="resource-vendor-title text-capitalize">{props.title}</h5>

      {/* Expertise Section */}
      {props.expIn && props.expIn.length > 0 && (
        <div className="resource-vendor-section">
          <div className="resource-vendor-tag">Expertise</div>
          <div className="resource-expertise-tags">
            {(props.expIn || []).slice(0, 3).map((item, i) => (
              <span key={i} className="resource-expertise-tag">
                {item.expertise_name}
              </span>
            ))}
            {props.expIn.length > 3 && (
              <span className="resource-expertise-tag more-tag">
                +{props.expIn.length - 3}
              </span>
            )}
          </div>
        </div>
      )}

      {/* Contact Details */}
      <div className="resource-vendor-contact">
        {props.email && <div className="contact-tag">📧 {props.email}</div>}
        {(props.data?.phone_no || props.data?.mobile) && (
          <div className="contact-tag">📞 {props.data.phone_no || props.data.mobile}</div>
        )}
      </div>

      {/* Action */}
      {isLoggedIn && (
        <div className="resource-vendor-action">
          <button
            className="btn btn-outline-primary brochure-btn"
            onClick={() => props.history.push(props.path)}
          >
            View Details
          </button>
        </div>
      )}
    </div>
  );
}
